import { z } from 'zod'

export const adUnitsAttributesSchema = z.object({
  adUnitsAttributes: z.record(z.string(), z.boolean()),
})

export type AdUnitsAttributesSchema = z.infer<typeof adUnitsAttributesSchema>
